import React from 'react';

import { ContentLayout } from './components';
import ConciergeInputs from './ConciergeInputs';
import SendNotifications from './SendNotifications';
import HoldAppointment from './HoldAppointment';

type ConciergeContentProps = {
  conciergeInputsDisabled: boolean;
};

const ConciergeContent: React.FC<ConciergeContentProps> = ({
  conciergeInputsDisabled,
}) => (
  <ContentLayout
    detailsSection={<ConciergeInputs disabled={conciergeInputsDisabled} />}
    notificationsSection={<SendNotifications />}
    permissionsSection={<HoldAppointment />}
  />
);

export default ConciergeContent;
